import { View } from 'native-base';
import React from 'react';
import DateScreen from './com/DateScreen';
import Header from './com/Header';

const Index = ({ route }) => {
    const { params = {} } = route;
    return (
        <View flex={1}>
            <DateScreen provider_id={params?.provider_id} />
        </View>
    );
};

export default Index;